import { Title, Card } from '@/components'

export const Profile = ({ data }: any) => (
  <div className="px-4 sm:px-6 lg:px-8 pt-6 pb-16">
    <div className="sm:flex sm:items-center mb-6">
      <div className="sm:flex-auto">
        <Title as="h1" size="lg">
          Your Profile
        </Title>
      </div>
    </div>
    <Card className="max-w-3xl">
      <div className="flex items-center gap-6">
        {data?.image ? (
          <div className="inline-block h-24 w-24 dark:bg-zinc-700 bg-zinc-100 rounded-md overflow-hidden">
            <img src={data.image} alt={data.name} className="h-24" />
          </div>
        ) : null}
        <Title as="p" size="lg">
          {data?.name}
        </Title>
      </div>
      <ul></ul>
    </Card>
  </div>
)
